import { render } from "./PostCommentsCollection.vue?vue&type=template&id=225086ed"
import script from "./PostCommentsCollection.vue?vue&type=script&lang=js"
export * from "./PostCommentsCollection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__